module.exports = __webpack_public_path__ + "static/media/ba.b2a453d5.svg";